import classNames from 'classnames';
import { createElement, forwardRef, useContext } from 'rax';
import View from '../view';
import Form from '../form';
import { useValue, useGuid } from '../utils/hooks';
import { getDefaultItemRender, useTouchChangeEventProps } from './utils';
const Rating = (props, ref) => {
    const { prefix = 'mt-', size: sizeProp, disabled = false, readOnly = false, count = 5, iconType = 'favorites-filling', onChange, className, style, allowHalf = false, itemRender: propsItemRender, } = props;
    const [value, setValue, isControlled] = useValue(props, 0);
    const { contentAlign, size: contextSize } = useContext(Form.ItemContext);
    const size = sizeProp || contextSize;
    const id = useGuid('rating-');
    const gradeType = value > count * 0.4 ? 'high' : 'low';
    const iconClassName = classNames(`${prefix}rating--${size}-icon`, `${prefix}rating-icon`);
    const classnames = {
        rating: classNames(`${prefix}rating`, `${prefix}rating--${size}`, `${prefix}rating--${contentAlign}`, `${prefix}rating--grade-${gradeType}`, {
            [`${prefix}rating--readonly`]: readOnly,
            [`${prefix}rating--disabled`]: disabled,
        }, className),
        iconWrapper: classNames(`${prefix}rating--${size}-icon-wrapper`, `${prefix}rating-icon-wrapper`),
        icon: iconClassName,
        activeIcon: classNames(iconClassName, `${prefix}rating-icon--active`, `${prefix}rating-icon--active-${gradeType}`),
    };
    const handleChange = (v) => {
        if (disabled || readOnly || v < 0) {
            return;
        }
        if (!isControlled) {
            setValue(v);
        }
        if (onChange) {
            onChange(v);
        }
    };
    const touchProps = useTouchChangeEventProps({
        id,
        disabled: disabled || readOnly,
        count,
        allowHalf,
        value,
        onChange: handleChange,
    });
    const itemRender = propsItemRender ||
        getDefaultItemRender({
            value,
            iconType,
            size,
            classnames,
        });
    const stars = [];
    for (let i = 0; i < count; i++) {
        const isActive = Math.floor(value - 1) >= i;
        const isHalfActive = value - i < 1 && value - i > 0;
        stars.push(<View key={i} className={classNames(classnames.iconWrapper, {
                [`${classnames.iconWrapper}--first`]: i === 0,
                [`${classnames.iconWrapper}--last`]: i === count - 1,
            })}>
        {itemRender({ key: i, value, count, isActive, isHalfActive })}
      </View>);
    }
    return (<View ref={ref} className={classnames.rating} id={id} style={style} {...touchProps}>
      {stars}
    </View>);
};
Rating.displayName = 'Rating';
export default forwardRef(Rating);
